import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PDPNotification from 'components/consumer/PDP/PDPNotification';
import useScreen from 'hooks/useScreen';
import DeliveryItem from './items/DeliveryItem';
import BuyNowPayLaterItem from './items/BuyNowPayLaterItem';
import WarrantyItem from './items/WarrantyItem';
import DesignServicesItem from './items/DesignServicesItem';
import FreeSwatchKitItem from './items/FreeSwatchKitItem';
const KeySellingPointsBar = () => {
  const $ = _c(11);
  const [mobileModalOpen, setMobileModalOpen] = useState(false);
  const [mobileModalContent, setmobileModalContent] = useState("");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      icon: null,
      cta: null
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [mobileModalIcon, setmobileModalIcon] = useState(t0);
  const {
    isMobileOrTablet
  } = useScreen();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = t2 => {
      const {
        content: t3,
        icon: t4,
        cta: t5
      } = t2;
      const content = t3 === undefined ? "" : t3;
      const icon = t4 === undefined ? null : t4;
      const cta = t5 === undefined ? null : t5;
      setmobileModalContent(content);
      setmobileModalIcon({
        icon,
        cta
      });
      setMobileModalOpen(true);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const openModal = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setMobileModalOpen(false);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const closeModal = t2;
  let t3;
  if ($[3] !== isMobileOrTablet || $[4] !== mobileModalContent || $[5] !== mobileModalIcon || $[6] !== mobileModalOpen) {
    t3 = mobileModalOpen && isMobileOrTablet && <PDPNotification baseMargin={true} brandedBG={true} heading={mobileModalContent} onClose={closeModal} showIcon={mobileModalIcon.icon} showCTA={mobileModalIcon.cta} />;
    $[3] = isMobileOrTablet;
    $[4] = mobileModalContent;
    $[5] = mobileModalIcon;
    $[6] = mobileModalOpen;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="text-base bg-gray-light8 text-gray flex h-[62px] justify-center p-0 w-full md:h-20"><div className="bg-gray-light8 flex flex-row max-w-[100vw] overflow-x-auto w-auto lg:px-[5px] lg:py-0"><DeliveryItem openMobileModal={openModal} /><BuyNowPayLaterItem openMobileModal={openModal} /><WarrantyItem openMobileModal={openModal} /><DesignServicesItem openMobileModal={openModal} /><FreeSwatchKitItem openMobileModal={openModal} /></div></div>;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3) {
    t5 = <>{t3}{t4}</>;
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default KeySellingPointsBar;